export default __webpack_public_path__ + "static/media/uniBg.550f2a69.png";